import { CanvasType, OpenPluginType, PluginEnum } from '@meitu/saas-editor-core/es/version-types';
import { CollapseType } from '@meitu/saas-editor-ui/es/types';
import { checkTypeIsPPT } from '@meitu/saas-editor-ui/es/utils/stage';
import { AI_MATTING_IMAGE } from '@/editor/extensions/ai-matting/components/ai-matting-extension';
import { isIntl } from '@/react-process-env';
import { FetchTemplateDetailDetailType, SdkModuleName } from '@/types';
import { checkImageEditor, isFromHuaweiCustom } from '@/utils/common';
import { getQueryParam } from '@/utils/query';

const feature = getQueryParam('feature');

const url = getQueryParam('open');

const isEmptyPoster = getQueryParam('createEmptyPoster');

const origin = getQueryParam('origin');

/**
 * 扩图、局部重绘等需要带上url
 * @returns 是否可以跳转到更多菜单
 */
function canJump2Plugin() {
    return (
        ([
            PluginEnum.AI_EXPEND_IMAGE,
            PluginEnum.AI_MODIFY_IMAGE,
            PluginEnum.IMAGE_TRANSLATION,
            AI_MATTING_IMAGE,
        ].includes(feature) &&
            url) ||
        [PluginEnum.AI_RESIZE, PluginEnum.AI_TEXT, PluginEnum.BATCH_TEMPLATE].includes(feature)
    );
}

export function isInitAiText() {
    return feature === 'ai_text';
}

// 是否是收藏的网址进入的编辑器
const isFromCollectUrl = !document.referrer;

export function initMenu(
    canvasType: CanvasType,
    type?: FetchTemplateDetailDetailType,
    jump2MoreCollapse?: (data: OpenPluginType) => void,
) {
    let collapseType = checkImageEditor() ? CollapseType.ADJUST_MENU : CollapseType.TEMPLATE_MENU;
    const isPPT = checkTypeIsPPT(canvasType);
    const newTab = getQueryParam('newTab');

    //1.如果带feature 且是作图记录 则定位到我的 (优先)
    //2.如果作图记录没有带feature  如果是收藏的url，定位到我的 反之【海报编辑器定位添加，图片编辑器定位到调整】
    //3.如果newTab 则定位到我的
    if (type === FetchTemplateDetailDetailType.TYPE_RECORD && !isFromHuaweiCustom()) {
        if (feature === FetchTemplateDetailDetailType.TYPE_RECORD) {
            collapseType = CollapseType.MINE_MENU;
        } else {
            if (isFromCollectUrl) {
                collapseType = CollapseType.MINE_MENU;
            } else {
                collapseType = checkImageEditor() ? CollapseType.ADJUST_MENU : CollapseType.SHORTCUT_MENU;
            }
        }
        if (newTab) {
            collapseType = CollapseType.MINE_MENU;
        }
    }

    if (canvasType === CanvasType.VARIETY) {
        collapseType = CollapseType.NAVIGATOR_MENU;
    }

    if (isPPT) {
        collapseType = CollapseType.NAVIGATOR_MENU;
    }

    if (getQueryParam('aihbForm') && getQueryParam('format') === 'zip') {
        collapseType = CollapseType.NAVIGATOR_MENU;
    }

    //空白画布情况下
    // feature 功能  用来判断是否打开改图、扩图等插件
    if (!isPPT && isEmptyPoster && (!feature || !url)) {
        // 海外目前还没有开放SHORTCUT_MENU
        collapseType =
            isIntl || origin === SdkModuleName.template ? CollapseType.TEMPLATE_MENU : CollapseType.SHORTCUT_MENU;
    }

    //注意顺序  必须在空白画布情况下后面
    if (getQueryParam('panel') === 'more') {
        collapseType = CollapseType.MORE_MENU;
    }

    // 打开插件功能
    if (canJump2Plugin()) {
        collapseType = CollapseType.MORE_MENU;
        jump2MoreCollapse?.({ func: feature, hasTrackFunc: true });
    }

    return collapseType;
}
